import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sort",
  "use": "icon-sort-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-sort\"><path d=\"M10 3 8 1 6 3zM6 13l2 2 2-2zM5 4.5c.4 0 .8.2 1.1.5s.4.6.4 1v5.5H5V9H3.5v2.5H2V6c0-.4.1-.8.4-1 .3-.3.6-.4 1.1-.5zm-1.5 3H5V6H3.5zm10.5-3V6l-3 4h3v1.5H9.5V10l3-4h-3V4.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol